import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { Utils } from '../../../../../shared/utils';
import { BeneficiaryDto } from '../../../../dto/beneficiary.dto';
import { RsjInstructionOtherDocumentDto } from '../../dto/rsj-instruction-other-document.dto';

@Component({
  selector: 'app-rsj-instruction-other-documents',
  templateUrl: './rsj-instruction-other-documents.component.html',
  standalone: false,
})
export class RsjInstructionOtherDocumentsComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject();

  public otherDocumentsForm: UntypedFormGroup;
  public updated: boolean = false;
  public submitted: boolean = false;

  public maxFileSize: number = environment.UPLOAD_MAX_FILESIZE ?? 1000 * 1000 * 1.2;
  public maxFileSizeStr: string = Utils.humanFileSize(this.maxFileSize, true, 2);

  @Input() public rsjOtherDocuments: RsjInstructionOtherDocumentDto[];
  @Input() public beneficiary: BeneficiaryDto;
  @Input() public disabled: boolean;

  constructor(private readonly fb: UntypedFormBuilder) {}

  public ngOnInit(): void {
    this.initForm();
    this.initValueChangeHandlers();
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public onSubmit(): boolean {
    if (this.updated) {
      this.submitted = true;
    }
    return !this.updated || this.otherDocumentsForm.valid;
  }

  public getDtos(): RsjInstructionOtherDocumentDto[] {
    if (this.otherDocumentsForm.valid) {
      this.rsjOtherDocuments = (this.otherDocuments.value ?? []).filter((value: RsjInstructionOtherDocumentDto) => value.document !== null);
    }
    return this.rsjOtherDocuments;
  }

  public get otherDocuments(): UntypedFormArray {
    return this.otherDocumentsForm.controls.otherDocuments as UntypedFormArray;
  }

  public addNewDocument(): void {
    this.otherDocuments.push(
      this.fb.group({
        document: [],
        comment: [],
      }),
    );
  }

  public removeDocument(index: number): void {
    if (this.otherDocuments.length === 1) {
      this.otherDocuments.at(0).setValue({ document: null, comment: null } as RsjInstructionOtherDocumentDto);
    } else {
      this.otherDocuments.removeAt(index);
    }
  }

  private initForm(): void {
    this.otherDocumentsForm = this.fb.group({
      otherDocuments: this.fb.array(
        (this.rsjOtherDocuments?.length > 0 ? this.rsjOtherDocuments : [new RsjInstructionOtherDocumentDto()]).map((item) =>
          this.fb.group({
            document: [item.document],
            comment: [item.comment],
          }),
        ),
      ),
    });
    if (this.disabled) {
      this.otherDocumentsForm.disable({ emitEvent: false });
    }
  }

  private initValueChangeHandlers(): void {
    this.otherDocumentsForm.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => (this.updated = true));
  }
}
